import { KatapultElement, html } from '../../mixins/katapult-element.js';

import '@polymer/paper-toast/paper-toast.js';
import '../job-chooser/job-chooser.js';
import '../style-modules/paper-tooltip-style.js';
import '../style-modules/paper-menu-button-style.js';
import '../style-modules/paper-dialog-style.js';
import '../katapult-toolbar/katapult-toolbar.js';
import '../input-element/input-element.js';
import '../katapult-elements/katapult-button.js';
import { NotifyResizable } from '../../modules/NotifyResizable.js';
import { ToArray } from '../../modules/ToArray.js';

/* global firebase k */
class KatapultTaskSubmission extends KatapultElement {
  static get template() {
    return html`
      <style include="paper-tooltip-style paper-menu-button-style paper-dialog-style">
        paper-dialog-scrollable {
          --paper-dialog-scrollable: {
            max-height: 600px;
            max-width: 1000px;
          }
        }
        katapult-button:not([iconOnly]) {
          min-width: 75px;
        }
        [buttons] {
          gap: 8px;
        }
      </style>
      <firebase-document path="[[codeRequestsPath]]/task_type_options" data="{{taskTypeOptions}}" disabled="[[!signedIn]]"></firebase-document>
      <paper-toast id="toast" text="{{toastText}}" visible="false" duration="4000" allow-click-through>
        <span id="toastBody"></span>
      </paper-toast>
      <paper-dialog id="taskDialog" style="width: 500px;" entry-animation="scale-up-animation" exit-animation="fade-out-animation" no-cancel-on-outside-click always-on-top>
        <div title secondary-color>[[submissionType]] Task</div>
          <paper-dialog-scrollable id="taskFormScrollable" style="position: relative;">
            <div content>
              <katapult-drop-down class="taskTypeOptions formInput" name="type" slot="left" label="Task Type" disabled="{{isReadOnly(taskData.*)}}" on-selected-changed="taskTypeChanged" vertical-offset="-26" label-path="label" value-path="key" items="[[taskTypeOptions]]" value="{{formData.type}}" auto-validate error-message="Please fill in this field"></katapult-drop-down>
              <paper-input id="formTitle" name="title" class="formInput" value="{{formData.title}}" label="Task Title" auto-validate error-message="Please fill in this field" style="padding: 0px;"></paper-input>
              <iron-collapse id="extraFormInputs" opened="[[showFormInputs]]" on-transitioning-changed="resizeDialog">
                <paper-textarea class="formInput" name="description" value="{{formData.description}}" label="Description" auto-validate error-message="Please fill in this field"></paper-textarea>
                <div style="padding-bottom: 26px;">
                  <job-chooser id="jobChooser" user-group="[[userGroup]]" selected="{{formData.job_link_id}}" hide-folder-chooser underline label-float default-text="Assign Task to a Job" disabled="[[jobChooserDisabled]]" firebase-disabled="[[!signedIn]]"></job-chooser>
                </div>
                <iron-collapse opened="[[equal(formData.type, 'bug')]]" on-transitioning-changed="resizeDialog">
                  <paper-textarea class="formInput" name="intended" value="{{formData.intended}}" label="Intended Behavior" hidden\$="{{!equal(formData.type, 'bug')}}" auto-validate error-message="Please fill in this field"></paper-textarea>
                  <paper-input class="formInput" name="url" value="{{requestURL}}" label="URL" hidden\$="{{!equal(formData.type, 'bug')}}" auto-validate error-message="Please fill in this field" style="padding: 0px;"></paper-input>
                  <div style="display: flex">
                    <katapult-drop-down style="flex: 1; padding: 0px 10px 0px 0px" class="formInput" slot="left" hidden\$="{{!equal(formData.type, 'bug')}}" vertical-offset="-26" name="database" label="Database" items="[[databaseList]]" value="{{formData.database}}" auto-validate error-message="Please fill in this field"></katapult-drop-down>
                    <paper-input style="flex: 1; padding: 0px 0px 0px 10px" name="versionNum" class="formInput" hidden\$="{{!equal(formData.type, 'bug')}}" value="{{formData.versionNum}}" label="Code Version Number" auto-validate error-message="Please fill in this field"></paper-input>
                  </div>
                </iron-collapse>
                <div style="display: flex">
                  <katapult-drop-down style="flex: 1; padding: 2px 10px 0px 0px" class="formInput" name="priority" vertical-offset="-26" slot="left" label="Priority" items="[[priorityList]]" auto-validate value="{{formData.priority}}"  error-message="Please fill in this field"></katapult-drop-down>
                  <paper-input label="Deadline (optional):" id="formDeadline" name="deadline" value="{{formData.deadline}}" style="flex: 1; padding: 0px 0px 0px 10px" class="formInput" type="date" ></paper-input>
                </div>
                <template is="dom-if" if="[[isCoder]]">
                  <paper-input id="formRequestor" class="formInput" name="requestedBy" value="{{formData.requestedBy}}" label="Requestor" auto-validate error-message="Please fill in this field"></paper-input>
                </template>
                <div style="display:flex; flex-flow: row nowrap; padding: 8px 0;">
                  <katapult-button size="18" icon="upload" color="var(--secondary-color)" on-click="openImportFileInput" style="width: 150px;">Add Files</katapult-button>
                  <input id="taskScreenshots" hidden type="file" accept="image/*" on-change="updateFileNames" multiple>
                  <div style="margin-top: auto; margin-bottom: auto; margin-left: 5px;">[[fileNames]]</div>
                </div>
              </iron-collapse>
            </div>
          </paper-dialog-scrollable>
        </div>
        <div buttons>
          <katapult-button dialog-dismiss on-click="cancelPromptAction">Cancel</katapult-button>
          <katapult-button id="formSubmitButton" color="var(--secondary-color)" callback="formVerification">Submit</katapult-button>
        </div>
      </paper-dialog>
    `;
  }

  static get is() {
    return 'katapult-task-submission';
  }
  static get properties() {
    return {
      userGroup: String,
      submissionType: {
        type: String,
        value: 'Create'
      },
      isCoder: {
        type: Boolean,
        value: false
      },
      taskData: {
        type: Object,
        value: {}
      },
      databaseList: {
        type: Array,
        value: () => {
          return ['DCS', 'Pro', 'Utilis', 'Wi-Finity', 'DRG', 'PPL KWS', 'Other(Explain in Description)'];
        }
      },
      priorityList: {
        type: Array,
        value: () => {
          return ['low', 'medium', 'high'];
        }
      },
      showFormInputs: {
        type: Boolean,
        value: false
      },
      formData: {
        type: Object,
        value: {}
      },
      taskScreenshots: {
        type: Array,
        value: []
      },
      signedIn: {
        type: Boolean,
        value: false
      },
      jobId: {
        type: String,
        value: ''
      },
      codeRequestsPath: {
        type: String,
        value: ''
      },
      tasksPath: {
        type: String,
        value: 'tasks'
      }
    };
  }
  static get observers() {
    return ['populateFields(taskData.*)', 'checkShowFormInputs(formData.*)', 'updateFileNames(taskData.screenshots)'];
  }
  ready() {
    super.ready();

    this.addEventListener('drop', this.handleDrop, false);
  }
  equal(a, b) {
    return a == b;
  }
  toArray(a) {
    return ToArray(a);
  }
  open() {
    this.$.taskDialog.open();
  }
  close() {
    this.$.taskDialog.close();
  }
  toast(text, innerHTML, duration) {
    this.$.toast.hide();
    this.toastText = text;
    if (innerHTML != null) {
      this.$.toastBody.innerHTML = innerHTML;
    } else {
      this.set('$.toastBody.innerHTML', '');
    }
    if (duration != null) {
      this.set('$.toast.duration', duration);
    }
    this.$.toast.show();
  }
  isReadOnly() {
    if (this.taskData && Object.keys(this.taskData).length > 0) return true;
    else return false;
  }
  checkShowFormInputs() {
    if (this.formData.type) {
      this.showFormInputs = true;
      this.calcFormDataJobLinkId();
    } else this.showFormInputs = false;
  }
  populateFields() {
    if (this.taskData) this.set('formData', this.taskData);
    else this.set('formData', {});
  }
  resizeDialog() {
    NotifyResizable('resizeDialog', this.$.taskDialog, 1000);
  }
  updateFileNames(e) {
    this.fileNames = '';
    // if there is existing request data, add existing names to the string
    if (this.taskData && this.taskData.screenshots) {
      for (let key in this.taskData.screenshots) {
        this.fileNames += (this.taskData.screenshots[key].filename || 'Missing Title') + '; ';
      }
    }
    this.taskScreenshots = this.shadowRoot.querySelector('#taskScreenshots').files;
    if (this.taskScreenshots && this.taskScreenshots.length > 0) {
      for (let i = 0; i < this.taskScreenshots.length; i++) {
        this.fileNames += this.taskScreenshots[i].name + '; ';
      }
    }
  }
  openImportFileInput(e) {
    this.shadowRoot.querySelector('#taskScreenshots').click();
  }
  cancelPromptAction() {
    this.$.taskDialog.removeAttribute('katapult-drop-down-fit-into');
    this.fileNames = '';
    this.resetScrollPosition();
  }
  resetScrollPosition() {
    // reset the scroll boxes to be positioned at the top of the form
    this.$.taskFormScrollable.$.scrollable.scrollTop = 0;
  }
  taskTypeChanged(e) {
    // This code allows the task type dropdown to expand past the dialog. But then once you choose a type, the future drop-downs will fit into the dialog
    var dialog = this.$.taskDialog;
    if (e.target.value) {
      dialog.setAttribute('katapult-drop-down-fit-into', true);
    } else {
      dialog.removeAttribute('katapult-drop-down-fit-into');
    }
  }
  formVerification(e) {
    let formInputs = Array.from(this.shadowRoot.querySelectorAll('.formInput'));
    let filteredInputs = formInputs.filter((x) => !x.hidden);
    // submit the form if we made it this far
    this.formSubmit(filteredInputs);
  }
  async formSubmit(filteredInputs) {
    // reset the forms scroll positions
    this.resetScrollPosition();

    let push = {};
    let taskKey = FirebaseWorker.ref(`${this.codeRequestsPath}/${this.tasksPath}`).push().key;
    if (this.taskData.$key) taskKey = this.taskData.$key;
    // check if there are any screenshots to upload, if so then upload them to firebase storage
    // and store the download links in the push
    if (this.taskScreenshots.length > 0) {
      for (let i = 0; i < this.taskScreenshots.length; i++) {
        let file = this.taskScreenshots[i];
        // get the download url
        let key = FirebaseWorker.ref('/').push().key;
        let storageRef = firebase.storage().ref(`${this.codeRequestsPath}/uploads/${taskKey}/${file.name}`);
        await storageRef
          .getDownloadURL()
          .then((url) => {
            // if this image already exists, then just DO NOTHING
          })
          .catch(async (e) => {
            // this image doesn't exist, we have to put it in storage
            await storageRef.put(file).then(async (s) => {
              // push the download url to an array of screenshots
              await storageRef.getDownloadURL().then((url) => {
                push['screenshots/' + key] = {
                  url,
                  filename: file.name
                };
              });
            });
          });
      }
    }
    // populate update object
    for (let i = 0; i < filteredInputs.length; i++) {
      let input = filteredInputs[i];
      let name = input.getAttribute('name');
      push[name] = input.value || null;
      // if the user is a coder then get from the requestor field otherwise set the requestor to the user's email
      if (!this.taskData.$key) {
        if (this.isCoder && name == 'requestedBy') {
          push['requestedBy'] = input.value || firebase.auth().currentUser.email;
        } else push['requestedBy'] = firebase.auth().currentUser.email;
      }
    }

    // if applicable assign task to job or node
    if (this.taskData.assigned_node) {
      push['assigned_node'] = this.taskData.assigned_node;
    } else if (this.taskData.assigned_job) {
      push['assigned_job'] = this.taskData.assigned_job;
    }

    if (this.taskData.job_link_id) {
      push['job_link_id'] = this.taskData.job_link_id;
      push['assigned_job'] = this.taskData.job_link_id;
      // create the hash for the link to job
      if (this.taskData.assigned_node) {
        if (!this.taskData.assigned_node.includes(this.taskData.job_link_id)) {
          // if the assigned node's job key is not the same as the job_link_id then remove the assigned node property
          push['assigned_node'] = null;
          push['job_link_hash'] = `${this.taskData.job_link_id}`;
        } else {
          // if we have an assigned node for the task then add that to the hash
          push['job_link_hash'] = `${this.taskData.job_link_id}/n${this.taskData.assigned_node.split(':')[0]}`;
        }
      } else {
        push['job_link_hash'] = `${this.taskData.job_link_id}`;
      }
    }

    if (!this.taskData.$key) {
      push['status'] = 'open';
      // we only want to mark this task as coder submitted if we're submitting a task
      if (this.isCoder) {
        push['coderSubmitted'] = true;
      }
      // set the date to the epoch time now
      push['date_opened'] = Date.now();
      let path = `${this.codeRequestsPath}/${this.tasksPath}/${taskKey}`;
      if (push['type'] == 'billable') path = `${this.codeRequestsPath}/billable/${taskKey}`;
      FirebaseWorker.ref(path)
        .update(push)
        .then(() => {
          // close the request form
          this.$.taskDialog.close();
          this.formData = {};
          this.taskScreenshots = [];
          // throw a success toast
          this.toast('Task created successfully!');
        })
        .catch((error) => {
          // throw an error toast
          this.toast('Task creation failed, please try again');
          console.log(error);
        });
    } else if (this.taskData.$key) {
      let path = `${this.codeRequestsPath}/${this.tasksPath}/${taskKey}`;
      if (push['type'] == 'billable') path = `${this.codeRequestsPath}/billable/${taskKey}`;
      FirebaseWorker.ref(path)
        .update(push)
        .then(() => {
          // close the request form
          this.$.taskDialog.close();
          // throw a success toast
          this.toast('Task updated successfully!');
        })
        .catch((error) => {
          // throw an error toast
          this.toast('Task failed to update, please try again');
          console.log(error);
        });
    }
  }
  calcFormDataJobLinkId() {
    // if we are in a job already then disable the job-chooser and force it to be the current job
    if (this.jobId) {
      this.set('formData.job_link_id', this.jobId);
      this.jobChooserDisabled = true;
    } else {
      this.jobChooserDisabled = false;
    }
  }
}
window.customElements.define(KatapultTaskSubmission.is, KatapultTaskSubmission);
